<template>
  <div class="body">
    <div class="main">
      <div class="title">{{ title }}</div>
      <div class="from">
        <span>来源:</span>
        <span>{{ from }}</span>
        <span>{{ time }}</span>
      </div>
      <div class="content">
        <div class="con_title">
          <div class="con_title_inside">
            <div class="con_title_inside_title">
              <strong>{{ con_title_inside_title }}</strong>
            </div>
            <div class="con_title_inside_img">
              <img :src="tips_titleImg" alt="" />
            </div>
            <div class="con_title_inside_text">
              {{ con_title_inside_text }}
            </div>
          </div>
        </div>
        <div class="con_title1">
          <div class="con_title1_title">
            一、“脱保”车险超过一定时间折扣取消保费增加
          </div>
          <div class="con_title1_txt1">
            你说反正车放小区不开，不着急续保？那你可要关注这一点了。
            如果行驶习惯较好，本年没有发生交通事故，次年续保时会有一定折扣的，
            但是如果到期不续保超过一定期限，就不能享受折扣了。
          </div>
          <div class="con_title1_img">
            <img :src="tips_txtAdd" alt="" />
          </div>
          <div class="con_title1_txt2">
            比如上年车险保费是3000元，因为没有出过险，第二年买车险时，
            打折可以便宜好几百块。但是不在正常期限续保，就要多交这几百块，
            既多交了钱又没了保障，所以及时续保才划算。
          </div>
          <!-- 线 -->
          <div class="con_line"></div>
        </div>
        <div class="con_title1 cont_title2">
          <div class="con_title1_title">二、“脱保”发生事故损失全靠自己赔偿</div>
          <div class="con_title1_txt1">
            车险过期原因多种多样，一种可能是车主确实忘记了当初投保的具体日期，结果错过了规定续保期限；
            另外一种是一部分车主心存侥幸，如果前一年度未出险，会认为自身驾驶技术不错，觉得拖几天没有事，
            便不去及时续保。
          </div>
          <div class="con_title1_img">
            <img :src="tips_txtBreak" alt="" />
          </div>
          <div class="con_title1_txt2">
            与交费期长达数十年的寿险有60天的宽限期不同，包括车险在内的财产险一般都是一年一保，并没有宽限期，保险期限一过，保单就失效。
            不管保单失效时间多短，在保单失效期间发生的事故损伤及其他赔偿，都需要车主自负。
          </div>
          <!-- 线 -->
          <div class="con_line"></div>
        </div>
        <div class="con_title1 cont_title3">
          <div class="con_title1_title">三、“脱保”没有交强险上路属违法</div>
          <div class="con_title1_txt1">
            就交强险来说，车辆“脱保”不但无法获得理赔，还会受到处罚。交强险是强制性购买的险种，
            根据《道路交通安全法》规定，所有的机动车必须购买第三者强制责任保险，
            如果路面执勤的交警发现车辆没有购买交强险，将暂扣车辆，并且进行双倍处罚，
            直到补齐了保险手续，交管部门才可能将车辆归还。
          </div>
          <div class="con_title1_img">
            <img :src="tips_titleCar" alt="" />
          </div>
          <div class="con_title1_txt2">
            由于商业车险并非强制购买，其遵循的也是商业原则，也就是“脱保”车主无法获得保险公司的理赔，自己为损失买单。
          </div>
          <!-- 线 -->
          <div class="con_line"></div>
        </div>
        <div class="con_title1 cont_title4">
          <div class="con_title1_title">四、“脱保”再续保需要验车</div>
          <div class="con_title1_txt1">
            保险公司对于脱保的车辆要求投保车损险的话，再去续保时会要求验车，
            增加了投保手续，脱保后再去续保没省钱也没省事。
          </div>
          <!-- 线 -->
          <div class="con_line"></div>
        </div>
        <div class="cont_title5">
          <p>
            说了这么多，大家应该都了解爱车脱保的严重性了吧，紫金保险在这里提醒大家：
            <strong
              >车主续保宜早不宜迟，最好是提前给自己的爱车进行续保，以免临时因时间、手续等因素的延误导致车险“脱保”，
              造成您的安全或者财产方面的损失哦！</strong
            >
          </p>
        </div>
        <div class="ending_pic">
          <img :src="tips_txtCom" alt="" />
        </div>
      </div>
      <div class="end_gif">
        <img :src="endPic" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api.js";
export default {
  data() {
    return {
      title: "车险忘记按期续保会有什么后果？ 看完这些就明白",
      con_title_inside_title: "车险“脱保”",
      con_title_inside_text:
        "所谓“脱保”，就是没有在保险期截止前正常投保，使原保险标在一段时间内没有保障的情况。这样的“脱保”车辆出现马路上，出现事故该如何理赔？“脱保”又会带来哪些不良后果呢？",
      from: "紫金保险",
      time: "6天前",
      endPic: api.imgAllUrl + "/more_end.gif",
      tips_titleCar: api.imgAllUrl + "/tips_titleCar.jpg",
      tips_titleImg: api.imgAllUrl + "/tips_titleImg.jpg",
      tips_txtAdd: api.imgAllUrl + "/tips_txtAdd.jpg",
      tips_txtBreak: api.imgAllUrl + "/tips_txtBreak.jpg",
      tips_txtCom: api.imgAllUrl + "/tips_txtCom.jpg",
    };
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.body {
  width: 100%;
  min-height: 6rem;
  margin-bottom: 0.2rem;
  background: white;
  .main {
    width: 100%;
    min-height: 10rem;
    box-sizing: border-box;
    padding: 0.1rem;
    .title {
      width: 100%;
      min-height: 0.4rem;
      font-size: 0.2rem;
      line-height: 0.3rem;
      color: #333333;
      opacity: 1;
    }
    .from {
      width: 100%;
      height: 0.22rem;
      font-size: 0.14rem;
      margin-top: 0.05rem;
      span:nth-child(1) {
        font-size: 0.14rem;
        font-weight: 400;
        line-height: 0.25rem;
        color: #999999;
        opacity: 1;
      }
      span:nth-child(2) {
        font-size: 0.14rem;
        font-weight: 400;
        line-height: 0.25rem;
        color: #815dc4;
        opacity: 1;
        margin-left: 0.1rem;
      }
      span:nth-child(3) {
        font-size: 0.14rem;
        font-weight: 400;
        line-height: 0.25rem;
        color: #999999;
        opacity: 1;
        margin-left: 0.15rem;
      }
    }
    .content {
      width: 100%;
      min-height: 20rem;
      background: rgba(235, 220, 240, 0.52);
      margin-top: 0.2rem;
      padding: 0.1rem;
      box-sizing: border-box;
      .con_title {
        width: 100%;
        min-height: 4.3rem;
        border: 1px solid #333;
        padding: 0.05rem;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        .con_title_inside {
          width: 100%;
          min-height: 4.15rem;
          border: 1px solid #333;
          padding: 0.1rem 0.15rem 0.1rem 0.15rem;
          box-sizing: border-box;
          .con_title_inside_title {
            width: 100%;
            min-height: 0.42rem;
            background: rgba(25, 61, 122, 0.13);
            font-size: 0.42rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: rgb(255, 255, 255);
            text-shadow: rgb(25, 61, 122) 1px 1px, rgb(25, 61, 122) 1px -1px,
              rgb(25, 61, 122) -1px 1px, rgb(25, 61, 122) -1px -1px,
              rgb(25, 61, 122) 0px 1.4px, rgb(25, 61, 122) 0px -1.4px,
              rgb(25, 61, 122) -1.4px 0px;
          }
          .con_title_inside_img {
            width: 100%;
            height: 2rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .con_title_inside_text {
            width: 100%;
            height: 1.4rem;
            font-size: 0.12rem;
            color: rgb(25, 61, 122);
            display: flex;
            justify-content: center;
            align-items: center;
            letter-spacing: 2px;
            line-height: 2;
            text-indent: 2em;
            white-space: normal;
          }
        }
      }
      .con_title1 {
        margin-top: 0.2rem;
        width: 100%;
        min-height: 1rem;
        .con_title1_title {
          margin-top: 0.2rem;
          font-size: 0.17rem;
          color: rgb(255, 255, 255);
          letter-spacing: 0px;
          line-height: 1.6;
          text-shadow: rgba(181, 6, 5, 0.2) 1px -1px, rgb(25, 61, 122) 1px 1px,
            rgb(25, 61, 122) -1px 1px, rgb(25, 61, 122) -1px -1px,
            rgb(25, 61, 122) 1px 0px, rgb(25, 61, 122) 0px 1px,
            rgb(25, 61, 122) -1px 0px, rgb(25, 61, 122) 0px -1px;
        }
        .con_title1_txt1 {
          margin-top: 0.1rem;
          width: 100%;
          min-height: 1.2rem;
          font-size: 0.12rem;
          color: rgb(25, 61, 122);
          text-align: justify;
          letter-spacing: 2px;
          line-height: 2;
          text-indent: 2em;
          white-space: normal;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .con_title1_img {
          margin-top: 0.1rem;
          margin-bottom: 0.1rem;
          width: 100%;
          height: 2.4rem;
          background: gainsboro;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .con_title1_txt2 {
          width: 100%;
          min-height: 1.3rem;
          font-size: 0.12rem;
          color: rgb(25, 61, 122);
          text-align: justify;
          letter-spacing: 2px;
          line-height: 2;
          text-indent: 2em;
          white-space: normal;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .con_line {
        margin-top: 0.2rem;
        width: 50%;
        border: 1px solid rgb(166, 91, 203);
      }
      .cont_title5 {
        margin-top: 0.5rem;
        width: 100%;
        min-height: 1.7rem;
        background: rgba(197, 213, 231, 0.29);
        font-size: 0.12rem;
        color: rgb(25, 61, 122);
        text-align: justify;
        line-height: 2;
        letter-spacing: 2px;
        padding: 0.25rem;
        box-sizing: border-box;
        p {
          text-indent: 2em;
        }
      }
      .ending_pic {
        margin-top: 0.1rem;
        width: 100%;
        height: 2.4rem;
        background: gainsboro;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .end_gif {
      margin-top: 0.1rem;
      width: 100%;
      height: 1.5rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Tips/Tips.vue